<template>
  <AuthLayout v-if="isReady">
    <template #body>
      <div class="flex flex-col min-h-screen h-full bg-gray-100 p-2">
        <main class="h-[calc(100vh-101px)] max-h-[calc(100%-101px)] mb-[85px]">
          <notifications position="top right" />
          <router-view v-if="isReady" />
        </main>
        <Footer v-if="isReady" />
      </div>
    </template>
  </AuthLayout>
</template>

<script lang="ts" setup>
  import { ref, onMounted, provide } from 'vue';
  import Footer from '@/components/Footer.vue';
  import AuthLayout from '@/layout/AuthLayout.vue';
  import { Notifications } from '@kyvg/vue3-notification';
  import { getSession } from '@/indexedDB';
  import { DB } from '@/types';

  const db = ref<DB | null>(null);
  const isReady = ref(false);
  provide('DB', db.value);

  onMounted(async () => {
    console.log('deployed');
    db.value = await getSession('user');
    isReady.value = true;
  });
</script>

<style></style>
